import { formatBlockRegionSummary } from './utils/formatRegion';
import styles from './blocks.module.css';

/**
 * Dense block row for scannable maps (40+ blocks).
 * Whole row opens Edit; region details live in the sheet.
 */
export default function BlockCard({
    block,
    showUsage = true,
    onUsageClick,
    onEditBlock,
}) {
    const regions = Array.isArray(block?.regionDefinitions) ? block.regionDefinitions : [];
    const itemCount = block?.itemCount ?? 0;
    const summary = formatBlockRegionSummary(regions, 3);
    const name = block?.name || 'Unnamed';

    const handleRowActivate = () => {
        onEditBlock?.(block);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleRowActivate();
        }
    };

    return (
        <article
            className={styles.blockRow}
            role="button"
            tabIndex={0}
            onClick={handleRowActivate}
            onKeyDown={handleKeyDown}
            aria-label={`Edit block ${name}`}
        >
            <div className={styles.blockRowLetter} aria-hidden="true">
                {name}
            </div>

            <div className={styles.blockRowMain}>
                <p className={styles.blockRowSummary} title={summary.full}>
                    {summary.text}
                </p>
                {showUsage && (
                    <span className={styles.blockRowMeta}>
                        {itemCount > 0 ? (
                            onUsageClick ? (
                                <button
                                    type="button"
                                    className={styles.linkButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onUsageClick(block);
                                    }}
                                >
                                    {itemCount} slide{itemCount === 1 ? '' : 's'}
                                </button>
                            ) : (
                                `${itemCount} slide${itemCount === 1 ? '' : 's'}`
                            )
                        ) : (
                            'Unused'
                        )}
                    </span>
                )}
            </div>

            <span className={styles.blockRowAction} aria-hidden="true">
                Edit
            </span>
        </article>
    );
}
